// src/components/Navbar.js
import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { Link as ScrollLink } from 'react-scroll';

const Navbar = () => (
  <AppBar
    position="sticky"
    sx={{
      backgroundColor: 'rgba(193, 224, 245, 0.9)', // Light, translucent background
      color: '#333',
      boxShadow: 'none',
      fontFamily: 'Poppins, sans-serif', // Set default font for the navbar
    }}
  >
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', paddingX: '20px' }}>
      {/* Brand Name with Custom Font */}
      <Typography
        variant="h6"
        component="div"
        sx={{
          fontFamily: 'Roboto Slab, serif',
          fontWeight: 'bold',
          fontSize: '1.5rem',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        Ganesh Neupane
        <a
          href="https://americandreamrealty.homes"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: '#1a365d',
            color: '#fff',
            textDecoration: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            fontSize: '0.9rem',
            fontFamily: 'Poppins, sans-serif',
            transition: 'background-color 0.3s',
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#2c4a7c'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#1a365d'}
        >
          American Dream Realty
        </a>
      </Typography>

      {/* Navbar Links */}
      <div>
        {/* Define links with specific targets */}
        {[
          { name: 'About', to: 'home' },
          { name: 'Properties', to: 'properties' },
          { name: 'Contact', to: 'contact' },
        ].map((section) => (
          <Button
            key={section.name}
            color="inherit"
            component={ScrollLink}
            to={section.to}
            smooth={true}
            duration={500}
            offset={-70} // Offset to account for fixed navbar height
            style={{ marginLeft: '10px', fontWeight: 'bold', fontFamily: 'Poppins, sans-serif' }}
          >
            {section.name}
          </Button>
        ))}
      </div>
    </Toolbar>
  </AppBar>
);

export default Navbar;
